(() => {
  const STORAGE_KEY = "beyours_discount_code";

  function getInput() {
    // Du kannst später den Selector anpassen oder dem Input ein data-Attribut geben.
    return document.querySelector('[data-discount-code-input]') ||
           document.querySelector('input[name="discount_code"]') ||
           document.querySelector('#CartDiscountCode');
  }

  function getCode() {
    const input = getInput();
    return input ? input.value.trim() : "";
  }

  // optional: Code im Browser merken (hilft bei Cart Drawer)
  document.addEventListener("input", (e) => {
    const input = getInput();
    if (input && e.target === input) {
      localStorage.setItem(STORAGE_KEY, input.value || "");
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    const input = getInput();
    const saved = localStorage.getItem(STORAGE_KEY);
    if (input && saved && !input.value) input.value = saved;
  });

  document.addEventListener("click", (e) => {
    // trifft Cart Drawer + Cart Page Checkout-Buttons in vielen Themes
    const checkoutEl = e.target.closest(
      '[data-checkout-button], [name="checkout"], a[href*="/checkout"]'
    );
    if (!checkoutEl) return;

    const code = getCode();
    if (!code) return; // kein Code -> normaler Checkout

    e.preventDefault();
    window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=/checkout`);
  });
})();
